"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.removeAction = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _m = require("@mutant-ws/m");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source))).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var debug = require("debug")("ReduxList:RemoveAction");

/**
 * Call list.remove method to remove item from slice.items
 *
 * @param {String}   listName    Slice name - for error messages
 * @param {Function} dispatch    Redux dispatch
 * @param {Function} api         API method
 * @param {Function} onChange    Appy on items array before changing state
 *
 * @param {string|number} id   Id of item to delete
 * @param {Array}         rest Other paramaters passed when calling list
 *                             instance .remove
 *
 * @return {Promise<Object<error, result>>}
 */
var removeAction = function removeAction(_ref) {
  var listName = _ref.listName,
      dispatch = _ref.dispatch,
      api = _ref.api,
      hasDispatchStart = _ref.hasDispatchStart,
      hasDispatchEnd = _ref.hasDispatchEnd,
      onChange = _ref.onChange;
  return function (id) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    if ((0, _m.isEmpty)(id)) {
      var _context;

      throw new TypeError((0, _concat.default)(_context = "ReduxList: \"".concat(listName, "\".remove ID param missing. Expected something, got \"")).call(_context, (0, _stringify.default)(id), "\""));
    }

    if (hasDispatchStart) {
      dispatch({
        type: "".concat(listName, "_REMOVE_START"),
        payload: id
      });
    }

    return _promise.default.resolve().then(function () {
      var _context2;

      return api.apply(void 0, (0, _concat.default)(_context2 = [id]).call(_context2, rest));
    }).then(function (result) {
      if (hasDispatchEnd) {
        dispatch({
          type: "".concat(listName, "_REMOVE_END"),
          payload: {
            listName: listName,
            item: _objectSpread(_objectSpread({}, result), {}, {
              id: (0, _m.hasKey)("id")(result) ? result.id : id
            }),
            onChange: onChange
          }
        });
      }

      return {
        result: result
      };
    }).catch(function (error) {
      // reducer and promise resolve the same data
      error.date = new Date();
      dispatch({
        type: "".concat(listName, "_REMOVE_ERROR"),
        payload: error
      });
      return {
        error: error
      };
    });
  };
};

exports.removeAction = removeAction;